<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <v-alert :value="alert" type="success">Başarıyla kaldedildi.</v-alert>
      </v-flex>
      <v-flex xs12 md12>
        <v-flex xs12 md12>
          <v-switch
              v-model="stockGroup.isAllProduct"
              @change="changeAllProduct"
              :label="`Ürünlerin Hepsini Seç: ${setState(stockGroup.isAllProduct)}`"
          ></v-switch>
        </v-flex>
      </v-flex>
      <v-flex xs12 md12>
        <v-combobox
            v-model="select"
            :items="this.$store.getters['products/productCategories']"
            item-value="id"
            multiple
            item-text="name"
            hide-details
            label="Ürün Seçiniz"
        ></v-combobox>
      </v-flex>
      <v-flex xs12 md12>
        <v-text-field v-model="stockGroup.stock" label="Stok Sayısı" :counter="max" required></v-text-field>
      </v-flex>
      <v-flex xs12 md12>
        <v-switch v-model="stockGroup.state" :label="`Aktif Mi:`"></v-switch>
      </v-flex>
      <v-btn color="success" @click="saveStockGroup">Kaydet</v-btn>
    </v-layout>
  </v-container>
</template>
<script>

export default {
  data: () => ({
    select: [],
    selectCategory: {},
    alert: false,
    // stockGroup: {
    //   status: false
    // },
    allowSpaces: false,
    match: "Foobar",
    max: 0,
    model: "Foobar",
    stockGroup: {
      state: true
    }
  }),

  watch: {},

  methods: {
    setState(state) {
      if (state) return "Aktif";
      return "Pasif";
    },
    changeAllProduct(categoryids) {
      if (categoryids) {
        this.select = this.$store.getters["products/productCategories"];
      } else {
        this.select = [];
      }
    },
    async saveStockGroup() {
      let stockGroup = Object.assign({}, this.stockGroup);
      stockGroup.productIds = this.select.map((m) => m.id).join(",");
      if (this.stockGroup.id) this.$store.dispatch("stockGroups/putStockGroup", stockGroup);
      else this.$store.dispatch("stockGroups/postStockGroup", stockGroup);
      this.alert = true;
    },
  },
  computed: {},
  async mounted() {
    await this.$store.dispatch("products/getProductsByMpProducts");
    
    if (this.$route.params.id) {
      await this.$store.dispatch("stockGroups/getStockGroup", this.$route.params.id);
      this.stockGroup = this.$store.state.stockGroups.stockGroup;
      if (this.stockGroup.productIds) {
        var ids = this.stockGroup.productIds.split(",").map(Number);
        this.select = this.$store.getters["products/productCategories"].filter(
            (x) => ids.includes(x.id)
        );
      }
    }
  },
  async created() {
  }
};
</script>